export const mobileRouter = [
  // 移动端中文版路由
  //#region 
  {
    path: "/",
    name: "chMobileIndex",
    component: () => import('@/views/mobile/mobile_index/mobile_index.vue'),
    meta: {
      language: 'ch'
    }

  },
  {
    path: "/casepresentation",
    name: "chMobile_CasePresentation",
    component: () => import('@/views/mobile/mobile_CasePresentation/mobile_CasePresentation.vue'),
    meta: {
      language: 'ch'
    }

  },
  {
    path: "/CaseDemonstration",
    name: "chMobile_CaseDemonstration",
    component: () => import('@/views/mobile/mobile_CaseDemonstration/mobile_CaseDemonstration.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/SoftwareSubscriptions",
    name: "chMobile_SoftwareSubscriptions",
    component: () => import('@/views/mobile/mobile_SoftwareSubscriptions/mobile_SoftwareSubscriptions.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/projection",
    name: "chMobileProjection",
    component: () => import('@/views/mobile/mobile_projection/mobile_projection.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/lightingDesign",
    name: "chMobileLightingDesign",
    component: () => import('@/views/mobile/mobile_lightingDesign/mobile_lightingDesign.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/offlineversion",
    name: "chMobile_offlineversion",
    component: () => import('@/views/mobile/mobile_offlineversion/mobile_offlineversion.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/projectorbit",
    name: "chMobile_projectorbit",
    component: () => import('@/views/mobile/mobile_projectorbit/mobile_projectorbit.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/construction",
    name: "chMobile_construction",
    component: () => import('@/views/mobile/mobile_construction/mobile_construction.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/virtualProduction",
    name: "chMobileVirtual",
    component: () => import('@/views/mobile/mobile_virtual/mobile_virtual.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/renderInteraction",
    name: "chMobileRender",
    component: () => import('@/views/mobile/mobile_render/mobile_render.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/understand",
    name: "chMobileUnderstand",
    component: () => import('@/views/mobile/mobile_understand/mobile_understand.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/studio",
    name: "chMobile_studio",
    component: () => import('@/views/mobile/mobile_studio/mobile_studio.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/hecoosLighting",
    name: "chMobileHecoosLighting",
    component: () => import('@/views/mobile/mobile_hecoos_lighting/mobile_hecoos_lighting.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/mediaServer",
    name: "chMobileHecoosServer",
    component: () => import('@/views/mobile/mobile_hecoos_server/mobile_hecoos_server.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/Register",
    name: "chMobileRegister",
    component: () => import('@/views/mobile/mobile_register/mobile_register.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/login",
    name: "chMobileLogin",
    component: () => import('@/views/mobile/mobile_login/mobile_login.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/video_tutorial",
    name: "chMobileVideoTutorial",
    component: () => import('@/views/mobile/mobile_videoTutorial/mobile_videoTutorial.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/forget_password",
    name: "chMobileForgetPassword",
    component: () => import('@/views/mobile/mobile_forgetPassword/mobile_forgetPassword.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/personalCenter",
    name: "chMobilePersonalCenter",
    component: () => import('@/views/mobile/mobile_personalCenter/mobile_personalCenter.vue'),
    meta: {
      language: 'ch'
    }
  },
  {
    path: "/paySuccess",
    name: "chMobilePaySuccess",
    component: () => import('@/views/mobile/mobile_paySuccess/mobile_paySuccess.vue'),
    meta: {
      language: 'ch'
    }
  },
  //#endregion

  // 移动端英文版路由
  //#region 
  {
    path: "/en",
    name: "enMobileIndex",
    component: () => import('@/views/en_mobile/mobile_index/mobile_index.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/casepresentation",
    name: "enMobile_CasePresentation",
    component: () => import('@/views/en_mobile/mobile_CasePresentation/mobile_CasePresentation.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/CaseDemonstration",
    name: "enMobile_CaseDemonstration",
    component: () => import('@/views/en_mobile/mobile_CaseDemonstration/mobile_CaseDemonstration.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/SoftwareSubscriptions",
    name: "enMobile_SoftwareSubscriptions",
    component: () => import('@/views/en_mobile/mobile_SoftwareSubscriptions/mobile_SoftwareSubscriptions.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/projection",
    name: "enMobileProjection",
    component: () => import('@/views/en_mobile/mobile_projection/mobile_projection.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/lightingDesign",
    name: "enMobileLightingDesign",
    component: () => import('@/views/en_mobile/mobile_lightingDesign/mobile_lightingDesign.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/offlineversion",
    name: "enMobile_offlineversion",
    component: () => import('@/views/en_mobile/mobile_offlineversion/mobile_offlineversion.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/projectorbit",
    name: "enMobile_projectorbit",
    component: () => import('@/views/en_mobile/mobile_projectorbit/mobile_projectorbit.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/construction",
    name: "enMobile_construction",
    component: () => import('@/views/en_mobile/mobile_construction/mobile_construction.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/virtualProduction",
    name: "enMobileVirtual",
    component: () => import('@/views/en_mobile/mobile_virtual/mobile_virtual.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/renderInteraction",
    name: "enMobileRender",
    component: () => import('@/views/en_mobile/mobile_render/mobile_render.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/understand",
    name: "enMobileUnderstand",
    component: () => import('@/views/en_mobile/mobile_understand/mobile_understand.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/studio",
    name: "enMobile_studio",
    component: () => import('@/views/en_mobile/mobile_studio/mobile_studio.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/hecoosLighting",
    name: "enMobileHecoosLighting",
    component: () => import('@/views/en_mobile/mobile_hecoos_lighting/mobile_hecoos_lighting.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/mediaServer",
    name: "enMobileHecoosServer",
    component: () => import('@/views/en_mobile/mobile_hecoos_server/mobile_hecoos_server.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/Register",
    name: "enMobileRegister",
    component: () => import('@/views/en_mobile/mobile_register/mobile_register.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/login",
    name: "enMobileLogin",
    component: () => import('@/views/en_mobile/mobile_login/mobile_login.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/video_tutorial",
    name: "enMobileVideoTutorial",
    component: () => import('@/views/en_mobile/mobile_videoTutorial/mobile_videoTutorial.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/forget_password",
    name: "enMobileForgetPassword",
    component: () => import('@/views/en_mobile/mobile_forgetPassword/mobile_forgetPassword.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/personalCenter",
    name: "enMobilePersonalCenter",
    component: () => import('@/views/en_mobile/mobile_personalCenter/mobile_personalCenter.vue'),
    meta: {
      language: 'en'
    }
  },
  {
    path: "/en/paySuccess",
    name: "enMobilePaySuccess",
    component: () => import('@/views/en_mobile/mobile_paySuccess/mobile_paySuccess.vue'),
    meta: {
      language: 'en'
    }
  },
  //#endregion
];